import React, { createContext, useContext, useReducer } from "react";

// 1. Create the context
const ConfigContext = createContext();

export const ChartType = {
  BAR: "bar",
  SCATTER: "scatter",
};

export const initialConfig = {
  chartType: ChartType.BAR,
  barSize: 20,
  theme: "light",
  apiBase: `${process.env.REACT_APP_API_URL}/api`,
  gradeScale: {
    A: { "color": "#56C271", min: 76, max: 100, description: "Excellent - Minimal risk, strong wellness across participants." },
    B: { "color": "#ffb100", min: 51, max: 75,  description: "Good – Some areas for improvement, generally positive." },
    C: { "color": "#f96f2f", min: 26, max: 50,  description: "Concerning – Notable gaps; intervention recommended." },
    D: { "color": "#CD5C5C", min: 0,  max: 25,  description: "Critical – Immediate attention required." },
    S: { "color": "gray",      min: -1, max: -1,  description: "Attention - Participant chose not to answer follow up question." },
  },
  maxScore: 100,
};

const configReduceer = (state, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

// 2. Create a provider component
export function ConfigProvider({ children }) {

  const [config, dispatch] = useReducer(configReduceer, initialConfig);
  return (
    <ConfigContext.Provider value={{ config, dispatch }}>
      {children}
    </ConfigContext.Provider>
  );
}

// 3. Create a custom hook for easy access
export function useConfig() {
  return useContext(ConfigContext);
}